/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as NoPermissionRouteImport } from './routes/no-permission'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PromptConfigurationIndexRouteImport } from './routes/prompt-configuration/index'
import { Route as FlowIndexRouteImport } from './routes/flow/index'
import { Route as plannerScreensPlannerRouteImport } from './routes/(planner-screens)/planner'
import { Route as SettingsEditableColumnsIndexRouteImport } from './routes/settings/editable-columns/index'
import { Route as Plant3MachinesIndexRouteImport } from './routes/plant-3/machines/index'
import { Route as Plant3ListIndexRouteImport } from './routes/plant-3/list/index'
import { Route as Plant3JobSchedulerIndexRouteImport } from './routes/plant-3/job-scheduler/index'
import { Route as Plant3AiRecommendationIndexRouteImport } from './routes/plant-3/ai-recommendation/index'
import { Route as plannerScreensPlannerIndexRouteImport } from './routes/(planner-screens)/planner/index'
import { Route as plannerScreensJobOrderIndexRouteImport } from './routes/(planner-screens)/job-order/index'
import { Route as Plant3MachinesScheduleRouteImport } from './routes/plant-3/machines/schedule'
import { Route as Plant3technicianScreensTechniciansRouteImport } from './routes/plant-3/(technician-screens)/technicians'
import { Route as Plant3processesScreensProcessesManagementRouteImport } from './routes/plant-3/(processes-screens)/processes-management'
import { Route as plannerScreensPlannerStatusOverviewRouteImport } from './routes/(planner-screens)/planner/status-overview'
import { Route as plannerScreensPlannerManPowerRouteImport } from './routes/(planner-screens)/planner/man-power'
import { Route as plannerScreensPlannerListRouteImport } from './routes/(planner-screens)/planner/list'
import { Route as plannerScreensPlannerKanbanRouteImport } from './routes/(planner-screens)/planner/kanban'
import { Route as plannerScreensPlannerGanttRouteImport } from './routes/(planner-screens)/planner/gantt'
import { Route as plannerScreensPlannerCalendarRouteImport } from './routes/(planner-screens)/planner/calendar'
import { Route as plannerScreensJobOrderTimeSelectionStepRouteImport } from './routes/(planner-screens)/job-order/time-selection-step'
import { Route as plannerScreensJobOrderReviewStepRouteImport } from './routes/(planner-screens)/job-order/review-step'
import { Route as SettingsEditableColumnsEditIndexRouteImport } from './routes/settings/editable-columns/edit/index'
import { Route as Plant3technicianScreensTechniciansIndexRouteImport } from './routes/plant-3/(technician-screens)/technicians/index'
import { Route as Plant3processesScreensProcessesManagementIndexRouteImport } from './routes/plant-3/(processes-screens)/processes-management/index'
import { Route as Plant3technicianScreensTechniciansScheduleRouteImport } from './routes/plant-3/(technician-screens)/technicians/schedule'
import { Route as Plant3technicianScreensTechniciansListRouteImport } from './routes/plant-3/(technician-screens)/technicians/list'
import { Route as Plant3technicianScreensTechniciansGroupedRouteImport } from './routes/plant-3/(technician-screens)/technicians/grouped'
import { Route as Plant3processesScreensProcessesManagementProcessesRouteImport } from './routes/plant-3/(processes-screens)/processes-management/processes'
import { Route as Plant3processesScreensProcessesManagementPartProcessesRouteImport } from './routes/plant-3/(processes-screens)/processes-management/part-processes'
import { Route as plannerScreensJobOrderIdAssignmentRouteImport } from './routes/(planner-screens)/job-order/$id.assignment'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const NoPermissionRoute = NoPermissionRouteImport.update({
  id: '/no-permission',
  path: '/no-permission',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptConfigurationIndexRoute =
  PromptConfigurationIndexRouteImport.update({
    id: '/prompt-configuration/',
    path: '/prompt-configuration/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlowIndexRoute = FlowIndexRouteImport.update({
  id: '/flow/',
  path: '/flow/',
  getParentRoute: () => rootRouteImport,
} as any)
const plannerScreensPlannerRoute = plannerScreensPlannerRouteImport.update({
  id: '/(planner-screens)/planner',
  path: '/planner',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEditableColumnsIndexRoute =
  SettingsEditableColumnsIndexRouteImport.update({
    id: '/settings/editable-columns/',
    path: '/settings/editable-columns/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Plant3MachinesIndexRoute = Plant3MachinesIndexRouteImport.update({
  id: '/plant-3/machines/',
  path: '/plant-3/machines/',
  getParentRoute: () => rootRouteImport,
} as any)
const Plant3ListIndexRoute = Plant3ListIndexRouteImport.update({
  id: '/plant-3/list/',
  path: '/plant-3/list/',
  getParentRoute: () => rootRouteImport,
} as any)
const Plant3JobSchedulerIndexRoute = Plant3JobSchedulerIndexRouteImport.update({
  id: '/plant-3/job-scheduler/',
  path: '/plant-3/job-scheduler/',
  getParentRoute: () => rootRouteImport,
} as any)
const Plant3AiRecommendationIndexRoute =
  Plant3AiRecommendationIndexRouteImport.update({
    id: '/plant-3/ai-recommendation/',
    path: '/plant-3/ai-recommendation/',
    getParentRoute: () => rootRouteImport,
  } as any)
const plannerScreensPlannerIndexRoute =
  plannerScreensPlannerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensJobOrderIndexRoute =
  plannerScreensJobOrderIndexRouteImport.update({
    id: '/(planner-screens)/job-order/',
    path: '/job-order/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Plant3MachinesScheduleRoute = Plant3MachinesScheduleRouteImport.update({
  id: '/plant-3/machines/schedule',
  path: '/plant-3/machines/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const Plant3technicianScreensTechniciansRoute =
  Plant3technicianScreensTechniciansRouteImport.update({
    id: '/plant-3/(technician-screens)/technicians',
    path: '/plant-3/technicians',
    getParentRoute: () => rootRouteImport,
  } as any)
const Plant3processesScreensProcessesManagementRoute =
  Plant3processesScreensProcessesManagementRouteImport.update({
    id: '/plant-3/(processes-screens)/processes-management',
    path: '/plant-3/processes-management',
    getParentRoute: () => rootRouteImport,
  } as any)
const plannerScreensPlannerStatusOverviewRoute =
  plannerScreensPlannerStatusOverviewRouteImport.update({
    id: '/status-overview',
    path: '/status-overview',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensPlannerManPowerRoute =
  plannerScreensPlannerManPowerRouteImport.update({
    id: '/man-power',
    path: '/man-power',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensPlannerListRoute =
  plannerScreensPlannerListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensPlannerKanbanRoute =
  plannerScreensPlannerKanbanRouteImport.update({
    id: '/kanban',
    path: '/kanban',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensPlannerGanttRoute =
  plannerScreensPlannerGanttRouteImport.update({
    id: '/gantt',
    path: '/gantt',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensPlannerCalendarRoute =
  plannerScreensPlannerCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => plannerScreensPlannerRoute,
  } as any)
const plannerScreensJobOrderTimeSelectionStepRoute =
  plannerScreensJobOrderTimeSelectionStepRouteImport.update({
    id: '/(planner-screens)/job-order/time-selection-step',
    path: '/job-order/time-selection-step',
    getParentRoute: () => rootRouteImport,
  } as any)
const plannerScreensJobOrderReviewStepRoute =
  plannerScreensJobOrderReviewStepRouteImport.update({
    id: '/(planner-screens)/job-order/review-step',
    path: '/job-order/review-step',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsEditableColumnsEditIndexRoute =
  SettingsEditableColumnsEditIndexRouteImport.update({
    id: '/settings/editable-columns/edit/',
    path: '/settings/editable-columns/edit/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Plant3technicianScreensTechniciansIndexRoute =
  Plant3technicianScreensTechniciansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Plant3technicianScreensTechniciansRoute,
  } as any)
const Plant3processesScreensProcessesManagementIndexRoute =
  Plant3processesScreensProcessesManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Plant3processesScreensProcessesManagementRoute,
  } as any)
const Plant3technicianScreensTechniciansScheduleRoute =
  Plant3technicianScreensTechniciansScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => Plant3technicianScreensTechniciansRoute,
  } as any)
const Plant3technicianScreensTechniciansListRoute =
  Plant3technicianScreensTechniciansListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => Plant3technicianScreensTechniciansRoute,
  } as any)
const Plant3technicianScreensTechniciansGroupedRoute =
  Plant3technicianScreensTechniciansGroupedRouteImport.update({
    id: '/grouped',
    path: '/grouped',
    getParentRoute: () => Plant3technicianScreensTechniciansRoute,
  } as any)
const Plant3processesScreensProcessesManagementProcessesRoute =
  Plant3processesScreensProcessesManagementProcessesRouteImport.update({
    id: '/processes',
    path: '/processes',
    getParentRoute: () => Plant3processesScreensProcessesManagementRoute,
  } as any)
const Plant3processesScreensProcessesManagementPartProcessesRoute =
  Plant3processesScreensProcessesManagementPartProcessesRouteImport.update({
    id: '/part-processes',
    path: '/part-processes',
    getParentRoute: () => Plant3processesScreensProcessesManagementRoute,
  } as any)
const plannerScreensJobOrderIdAssignmentRoute =
  plannerScreensJobOrderIdAssignmentRouteImport.update({
    id: '/(planner-screens)/job-order/$id/assignment',
    path: '/job-order/$id/assignment',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/callback': typeof CallbackRoute
  '/logout': typeof LogoutRoute
  '/no-permission': typeof NoPermissionRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/planner': typeof plannerScreensPlannerRouteWithChildren
  '/flow': typeof FlowIndexRoute
  '/prompt-configuration': typeof PromptConfigurationIndexRoute
  '/job-order/review-step': typeof plannerScreensJobOrderReviewStepRoute
  '/job-order/time-selection-step': typeof plannerScreensJobOrderTimeSelectionStepRoute
  '/planner/calendar': typeof plannerScreensPlannerCalendarRoute
  '/planner/gantt': typeof plannerScreensPlannerGanttRoute
  '/planner/kanban': typeof plannerScreensPlannerKanbanRoute
  '/planner/list': typeof plannerScreensPlannerListRoute
  '/planner/man-power': typeof plannerScreensPlannerManPowerRoute
  '/planner/status-overview': typeof plannerScreensPlannerStatusOverviewRoute
  '/plant-3/processes-management': typeof Plant3processesScreensProcessesManagementRouteWithChildren
  '/plant-3/technicians': typeof Plant3technicianScreensTechniciansRouteWithChildren
  '/plant-3/machines/schedule': typeof Plant3MachinesScheduleRoute
  '/job-order': typeof plannerScreensJobOrderIndexRoute
  '/planner/': typeof plannerScreensPlannerIndexRoute
  '/plant-3/ai-recommendation': typeof Plant3AiRecommendationIndexRoute
  '/plant-3/job-scheduler': typeof Plant3JobSchedulerIndexRoute
  '/plant-3/list': typeof Plant3ListIndexRoute
  '/plant-3/machines': typeof Plant3MachinesIndexRoute
  '/settings/editable-columns': typeof SettingsEditableColumnsIndexRoute
  '/job-order/$id/assignment': typeof plannerScreensJobOrderIdAssignmentRoute
  '/plant-3/processes-management/part-processes': typeof Plant3processesScreensProcessesManagementPartProcessesRoute
  '/plant-3/processes-management/processes': typeof Plant3processesScreensProcessesManagementProcessesRoute
  '/plant-3/technicians/grouped': typeof Plant3technicianScreensTechniciansGroupedRoute
  '/plant-3/technicians/list': typeof Plant3technicianScreensTechniciansListRoute
  '/plant-3/technicians/schedule': typeof Plant3technicianScreensTechniciansScheduleRoute
  '/plant-3/processes-management/': typeof Plant3processesScreensProcessesManagementIndexRoute
  '/plant-3/technicians/': typeof Plant3technicianScreensTechniciansIndexRoute
  '/settings/editable-columns/edit': typeof SettingsEditableColumnsEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/callback': typeof CallbackRoute
  '/logout': typeof LogoutRoute
  '/no-permission': typeof NoPermissionRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/flow': typeof FlowIndexRoute
  '/prompt-configuration': typeof PromptConfigurationIndexRoute
  '/job-order/review-step': typeof plannerScreensJobOrderReviewStepRoute
  '/job-order/time-selection-step': typeof plannerScreensJobOrderTimeSelectionStepRoute
  '/planner/calendar': typeof plannerScreensPlannerCalendarRoute
  '/planner/gantt': typeof plannerScreensPlannerGanttRoute
  '/planner/kanban': typeof plannerScreensPlannerKanbanRoute
  '/planner/list': typeof plannerScreensPlannerListRoute
  '/planner/man-power': typeof plannerScreensPlannerManPowerRoute
  '/planner/status-overview': typeof plannerScreensPlannerStatusOverviewRoute
  '/plant-3/machines/schedule': typeof Plant3MachinesScheduleRoute
  '/job-order': typeof plannerScreensJobOrderIndexRoute
  '/planner': typeof plannerScreensPlannerIndexRoute
  '/plant-3/ai-recommendation': typeof Plant3AiRecommendationIndexRoute
  '/plant-3/job-scheduler': typeof Plant3JobSchedulerIndexRoute
  '/plant-3/list': typeof Plant3ListIndexRoute
  '/plant-3/machines': typeof Plant3MachinesIndexRoute
  '/settings/editable-columns': typeof SettingsEditableColumnsIndexRoute
  '/job-order/$id/assignment': typeof plannerScreensJobOrderIdAssignmentRoute
  '/plant-3/processes-management/part-processes': typeof Plant3processesScreensProcessesManagementPartProcessesRoute
  '/plant-3/processes-management/processes': typeof Plant3processesScreensProcessesManagementProcessesRoute
  '/plant-3/technicians/grouped': typeof Plant3technicianScreensTechniciansGroupedRoute
  '/plant-3/technicians/list': typeof Plant3technicianScreensTechniciansListRoute
  '/plant-3/technicians/schedule': typeof Plant3technicianScreensTechniciansScheduleRoute
  '/plant-3/processes-management': typeof Plant3processesScreensProcessesManagementIndexRoute
  '/plant-3/technicians': typeof Plant3technicianScreensTechniciansIndexRoute
  '/settings/editable-columns/edit': typeof SettingsEditableColumnsEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/callback': typeof CallbackRoute
  '/logout': typeof LogoutRoute
  '/no-permission': typeof NoPermissionRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/(planner-screens)/planner': typeof plannerScreensPlannerRouteWithChildren
  '/flow/': typeof FlowIndexRoute
  '/prompt-configuration/': typeof PromptConfigurationIndexRoute
  '/(planner-screens)/job-order/review-step': typeof plannerScreensJobOrderReviewStepRoute
  '/(planner-screens)/job-order/time-selection-step': typeof plannerScreensJobOrderTimeSelectionStepRoute
  '/(planner-screens)/planner/calendar': typeof plannerScreensPlannerCalendarRoute
  '/(planner-screens)/planner/gantt': typeof plannerScreensPlannerGanttRoute
  '/(planner-screens)/planner/kanban': typeof plannerScreensPlannerKanbanRoute
  '/(planner-screens)/planner/list': typeof plannerScreensPlannerListRoute
  '/(planner-screens)/planner/man-power': typeof plannerScreensPlannerManPowerRoute
  '/(planner-screens)/planner/status-overview': typeof plannerScreensPlannerStatusOverviewRoute
  '/plant-3/(processes-screens)/processes-management': typeof Plant3processesScreensProcessesManagementRouteWithChildren
  '/plant-3/(technician-screens)/technicians': typeof Plant3technicianScreensTechniciansRouteWithChildren
  '/plant-3/machines/schedule': typeof Plant3MachinesScheduleRoute
  '/(planner-screens)/job-order/': typeof plannerScreensJobOrderIndexRoute
  '/(planner-screens)/planner/': typeof plannerScreensPlannerIndexRoute
  '/plant-3/ai-recommendation/': typeof Plant3AiRecommendationIndexRoute
  '/plant-3/job-scheduler/': typeof Plant3JobSchedulerIndexRoute
  '/plant-3/list/': typeof Plant3ListIndexRoute
  '/plant-3/machines/': typeof Plant3MachinesIndexRoute
  '/settings/editable-columns/': typeof SettingsEditableColumnsIndexRoute
  '/(planner-screens)/job-order/$id/assignment': typeof plannerScreensJobOrderIdAssignmentRoute
  '/plant-3/(processes-screens)/processes-management/part-processes': typeof Plant3processesScreensProcessesManagementPartProcessesRoute
  '/plant-3/(processes-screens)/processes-management/processes': typeof Plant3processesScreensProcessesManagementProcessesRoute
  '/plant-3/(technician-screens)/technicians/grouped': typeof Plant3technicianScreensTechniciansGroupedRoute
  '/plant-3/(technician-screens)/technicians/list': typeof Plant3technicianScreensTechniciansListRoute
  '/plant-3/(technician-screens)/technicians/schedule': typeof Plant3technicianScreensTechniciansScheduleRoute
  '/plant-3/(processes-screens)/processes-management/': typeof Plant3processesScreensProcessesManagementIndexRoute
  '/plant-3/(technician-screens)/technicians/': typeof Plant3technicianScreensTechniciansIndexRoute
  '/settings/editable-columns/edit/': typeof SettingsEditableColumnsEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/apps'
    | '/callback'
    | '/logout'
    | '/no-permission'
    | '/unauthorized'
    | '/planner'
    | '/flow'
    | '/prompt-configuration'
    | '/job-order/review-step'
    | '/job-order/time-selection-step'
    | '/planner/calendar'
    | '/planner/gantt'
    | '/planner/kanban'
    | '/planner/list'
    | '/planner/man-power'
    | '/planner/status-overview'
    | '/plant-3/processes-management'
    | '/plant-3/technicians'
    | '/plant-3/machines/schedule'
    | '/job-order'
    | '/planner/'
    | '/plant-3/ai-recommendation'
    | '/plant-3/job-scheduler'
    | '/plant-3/list'
    | '/plant-3/machines'
    | '/settings/editable-columns'
    | '/job-order/$id/assignment'
    | '/plant-3/processes-management/part-processes'
    | '/plant-3/processes-management/processes'
    | '/plant-3/technicians/grouped'
    | '/plant-3/technicians/list'
    | '/plant-3/technicians/schedule'
    | '/plant-3/processes-management/'
    | '/plant-3/technicians/'
    | '/settings/editable-columns/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/apps'
    | '/callback'
    | '/logout'
    | '/no-permission'
    | '/unauthorized'
    | '/flow'
    | '/prompt-configuration'
    | '/job-order/review-step'
    | '/job-order/time-selection-step'
    | '/planner/calendar'
    | '/planner/gantt'
    | '/planner/kanban'
    | '/planner/list'
    | '/planner/man-power'
    | '/planner/status-overview'
    | '/plant-3/machines/schedule'
    | '/job-order'
    | '/planner'
    | '/plant-3/ai-recommendation'
    | '/plant-3/job-scheduler'
    | '/plant-3/list'
    | '/plant-3/machines'
    | '/settings/editable-columns'
    | '/job-order/$id/assignment'
    | '/plant-3/processes-management/part-processes'
    | '/plant-3/processes-management/processes'
    | '/plant-3/technicians/grouped'
    | '/plant-3/technicians/list'
    | '/plant-3/technicians/schedule'
    | '/plant-3/processes-management'
    | '/plant-3/technicians'
    | '/settings/editable-columns/edit'
  id:
    | '__root__'
    | '/'
    | '/apps'
    | '/callback'
    | '/logout'
    | '/no-permission'
    | '/unauthorized'
    | '/(planner-screens)/planner'
    | '/flow/'
    | '/prompt-configuration/'
    | '/(planner-screens)/job-order/review-step'
    | '/(planner-screens)/job-order/time-selection-step'
    | '/(planner-screens)/planner/calendar'
    | '/(planner-screens)/planner/gantt'
    | '/(planner-screens)/planner/kanban'
    | '/(planner-screens)/planner/list'
    | '/(planner-screens)/planner/man-power'
    | '/(planner-screens)/planner/status-overview'
    | '/plant-3/(processes-screens)/processes-management'
    | '/plant-3/(technician-screens)/technicians'
    | '/plant-3/machines/schedule'
    | '/(planner-screens)/job-order/'
    | '/(planner-screens)/planner/'
    | '/plant-3/ai-recommendation/'
    | '/plant-3/job-scheduler/'
    | '/plant-3/list/'
    | '/plant-3/machines/'
    | '/settings/editable-columns/'
    | '/(planner-screens)/job-order/$id/assignment'
    | '/plant-3/(processes-screens)/processes-management/part-processes'
    | '/plant-3/(processes-screens)/processes-management/processes'
    | '/plant-3/(technician-screens)/technicians/grouped'
    | '/plant-3/(technician-screens)/technicians/list'
    | '/plant-3/(technician-screens)/technicians/schedule'
    | '/plant-3/(processes-screens)/processes-management/'
    | '/plant-3/(technician-screens)/technicians/'
    | '/settings/editable-columns/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppsRoute: typeof AppsRoute
  CallbackRoute: typeof CallbackRoute
  LogoutRoute: typeof LogoutRoute
  NoPermissionRoute: typeof NoPermissionRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  plannerScreensPlannerRoute: typeof plannerScreensPlannerRouteWithChildren
  FlowIndexRoute: typeof FlowIndexRoute
  PromptConfigurationIndexRoute: typeof PromptConfigurationIndexRoute
  plannerScreensJobOrderReviewStepRoute: typeof plannerScreensJobOrderReviewStepRoute
  plannerScreensJobOrderTimeSelectionStepRoute: typeof plannerScreensJobOrderTimeSelectionStepRoute
  Plant3processesScreensProcessesManagementRoute: typeof Plant3processesScreensProcessesManagementRouteWithChildren
  Plant3technicianScreensTechniciansRoute: typeof Plant3technicianScreensTechniciansRouteWithChildren
  Plant3MachinesScheduleRoute: typeof Plant3MachinesScheduleRoute
  plannerScreensJobOrderIndexRoute: typeof plannerScreensJobOrderIndexRoute
  Plant3AiRecommendationIndexRoute: typeof Plant3AiRecommendationIndexRoute
  Plant3JobSchedulerIndexRoute: typeof Plant3JobSchedulerIndexRoute
  Plant3ListIndexRoute: typeof Plant3ListIndexRoute
  Plant3MachinesIndexRoute: typeof Plant3MachinesIndexRoute
  SettingsEditableColumnsIndexRoute: typeof SettingsEditableColumnsIndexRoute
  plannerScreensJobOrderIdAssignmentRoute: typeof plannerScreensJobOrderIdAssignmentRoute
  SettingsEditableColumnsEditIndexRoute: typeof SettingsEditableColumnsEditIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-permission': {
      id: '/no-permission'
      path: '/no-permission'
      fullPath: '/no-permission'
      preLoaderRoute: typeof NoPermissionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompt-configuration/': {
      id: '/prompt-configuration/'
      path: '/prompt-configuration'
      fullPath: '/prompt-configuration'
      preLoaderRoute: typeof PromptConfigurationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flow/': {
      id: '/flow/'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof FlowIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(planner-screens)/planner': {
      id: '/(planner-screens)/planner'
      path: '/planner'
      fullPath: '/planner'
      preLoaderRoute: typeof plannerScreensPlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/editable-columns/': {
      id: '/settings/editable-columns/'
      path: '/settings/editable-columns'
      fullPath: '/settings/editable-columns'
      preLoaderRoute: typeof SettingsEditableColumnsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/machines/': {
      id: '/plant-3/machines/'
      path: '/plant-3/machines'
      fullPath: '/plant-3/machines'
      preLoaderRoute: typeof Plant3MachinesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/list/': {
      id: '/plant-3/list/'
      path: '/plant-3/list'
      fullPath: '/plant-3/list'
      preLoaderRoute: typeof Plant3ListIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/job-scheduler/': {
      id: '/plant-3/job-scheduler/'
      path: '/plant-3/job-scheduler'
      fullPath: '/plant-3/job-scheduler'
      preLoaderRoute: typeof Plant3JobSchedulerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/ai-recommendation/': {
      id: '/plant-3/ai-recommendation/'
      path: '/plant-3/ai-recommendation'
      fullPath: '/plant-3/ai-recommendation'
      preLoaderRoute: typeof Plant3AiRecommendationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(planner-screens)/planner/': {
      id: '/(planner-screens)/planner/'
      path: '/'
      fullPath: '/planner/'
      preLoaderRoute: typeof plannerScreensPlannerIndexRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/job-order/': {
      id: '/(planner-screens)/job-order/'
      path: '/job-order'
      fullPath: '/job-order'
      preLoaderRoute: typeof plannerScreensJobOrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/machines/schedule': {
      id: '/plant-3/machines/schedule'
      path: '/plant-3/machines/schedule'
      fullPath: '/plant-3/machines/schedule'
      preLoaderRoute: typeof Plant3MachinesScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/(technician-screens)/technicians': {
      id: '/plant-3/(technician-screens)/technicians'
      path: '/plant-3/technicians'
      fullPath: '/plant-3/technicians'
      preLoaderRoute: typeof Plant3technicianScreensTechniciansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/(processes-screens)/processes-management': {
      id: '/plant-3/(processes-screens)/processes-management'
      path: '/plant-3/processes-management'
      fullPath: '/plant-3/processes-management'
      preLoaderRoute: typeof Plant3processesScreensProcessesManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(planner-screens)/planner/status-overview': {
      id: '/(planner-screens)/planner/status-overview'
      path: '/status-overview'
      fullPath: '/planner/status-overview'
      preLoaderRoute: typeof plannerScreensPlannerStatusOverviewRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/planner/man-power': {
      id: '/(planner-screens)/planner/man-power'
      path: '/man-power'
      fullPath: '/planner/man-power'
      preLoaderRoute: typeof plannerScreensPlannerManPowerRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/planner/list': {
      id: '/(planner-screens)/planner/list'
      path: '/list'
      fullPath: '/planner/list'
      preLoaderRoute: typeof plannerScreensPlannerListRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/planner/kanban': {
      id: '/(planner-screens)/planner/kanban'
      path: '/kanban'
      fullPath: '/planner/kanban'
      preLoaderRoute: typeof plannerScreensPlannerKanbanRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/planner/gantt': {
      id: '/(planner-screens)/planner/gantt'
      path: '/gantt'
      fullPath: '/planner/gantt'
      preLoaderRoute: typeof plannerScreensPlannerGanttRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/planner/calendar': {
      id: '/(planner-screens)/planner/calendar'
      path: '/calendar'
      fullPath: '/planner/calendar'
      preLoaderRoute: typeof plannerScreensPlannerCalendarRouteImport
      parentRoute: typeof plannerScreensPlannerRoute
    }
    '/(planner-screens)/job-order/time-selection-step': {
      id: '/(planner-screens)/job-order/time-selection-step'
      path: '/job-order/time-selection-step'
      fullPath: '/job-order/time-selection-step'
      preLoaderRoute: typeof plannerScreensJobOrderTimeSelectionStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(planner-screens)/job-order/review-step': {
      id: '/(planner-screens)/job-order/review-step'
      path: '/job-order/review-step'
      fullPath: '/job-order/review-step'
      preLoaderRoute: typeof plannerScreensJobOrderReviewStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/editable-columns/edit/': {
      id: '/settings/editable-columns/edit/'
      path: '/settings/editable-columns/edit'
      fullPath: '/settings/editable-columns/edit'
      preLoaderRoute: typeof SettingsEditableColumnsEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plant-3/(technician-screens)/technicians/': {
      id: '/plant-3/(technician-screens)/technicians/'
      path: '/'
      fullPath: '/plant-3/technicians/'
      preLoaderRoute: typeof Plant3technicianScreensTechniciansIndexRouteImport
      parentRoute: typeof Plant3technicianScreensTechniciansRoute
    }
    '/plant-3/(processes-screens)/processes-management/': {
      id: '/plant-3/(processes-screens)/processes-management/'
      path: '/'
      fullPath: '/plant-3/processes-management/'
      preLoaderRoute: typeof Plant3processesScreensProcessesManagementIndexRouteImport
      parentRoute: typeof Plant3processesScreensProcessesManagementRoute
    }
    '/plant-3/(technician-screens)/technicians/schedule': {
      id: '/plant-3/(technician-screens)/technicians/schedule'
      path: '/schedule'
      fullPath: '/plant-3/technicians/schedule'
      preLoaderRoute: typeof Plant3technicianScreensTechniciansScheduleRouteImport
      parentRoute: typeof Plant3technicianScreensTechniciansRoute
    }
    '/plant-3/(technician-screens)/technicians/list': {
      id: '/plant-3/(technician-screens)/technicians/list'
      path: '/list'
      fullPath: '/plant-3/technicians/list'
      preLoaderRoute: typeof Plant3technicianScreensTechniciansListRouteImport
      parentRoute: typeof Plant3technicianScreensTechniciansRoute
    }
    '/plant-3/(technician-screens)/technicians/grouped': {
      id: '/plant-3/(technician-screens)/technicians/grouped'
      path: '/grouped'
      fullPath: '/plant-3/technicians/grouped'
      preLoaderRoute: typeof Plant3technicianScreensTechniciansGroupedRouteImport
      parentRoute: typeof Plant3technicianScreensTechniciansRoute
    }
    '/plant-3/(processes-screens)/processes-management/processes': {
      id: '/plant-3/(processes-screens)/processes-management/processes'
      path: '/processes'
      fullPath: '/plant-3/processes-management/processes'
      preLoaderRoute: typeof Plant3processesScreensProcessesManagementProcessesRouteImport
      parentRoute: typeof Plant3processesScreensProcessesManagementRoute
    }
    '/plant-3/(processes-screens)/processes-management/part-processes': {
      id: '/plant-3/(processes-screens)/processes-management/part-processes'
      path: '/part-processes'
      fullPath: '/plant-3/processes-management/part-processes'
      preLoaderRoute: typeof Plant3processesScreensProcessesManagementPartProcessesRouteImport
      parentRoute: typeof Plant3processesScreensProcessesManagementRoute
    }
    '/(planner-screens)/job-order/$id/assignment': {
      id: '/(planner-screens)/job-order/$id/assignment'
      path: '/job-order/$id/assignment'
      fullPath: '/job-order/$id/assignment'
      preLoaderRoute: typeof plannerScreensJobOrderIdAssignmentRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface plannerScreensPlannerRouteChildren {
  plannerScreensPlannerCalendarRoute: typeof plannerScreensPlannerCalendarRoute
  plannerScreensPlannerGanttRoute: typeof plannerScreensPlannerGanttRoute
  plannerScreensPlannerKanbanRoute: typeof plannerScreensPlannerKanbanRoute
  plannerScreensPlannerListRoute: typeof plannerScreensPlannerListRoute
  plannerScreensPlannerManPowerRoute: typeof plannerScreensPlannerManPowerRoute
  plannerScreensPlannerStatusOverviewRoute: typeof plannerScreensPlannerStatusOverviewRoute
  plannerScreensPlannerIndexRoute: typeof plannerScreensPlannerIndexRoute
}

const plannerScreensPlannerRouteChildren: plannerScreensPlannerRouteChildren = {
  plannerScreensPlannerCalendarRoute: plannerScreensPlannerCalendarRoute,
  plannerScreensPlannerGanttRoute: plannerScreensPlannerGanttRoute,
  plannerScreensPlannerKanbanRoute: plannerScreensPlannerKanbanRoute,
  plannerScreensPlannerListRoute: plannerScreensPlannerListRoute,
  plannerScreensPlannerManPowerRoute: plannerScreensPlannerManPowerRoute,
  plannerScreensPlannerStatusOverviewRoute:
    plannerScreensPlannerStatusOverviewRoute,
  plannerScreensPlannerIndexRoute: plannerScreensPlannerIndexRoute,
}

const plannerScreensPlannerRouteWithChildren =
  plannerScreensPlannerRoute._addFileChildren(
    plannerScreensPlannerRouteChildren,
  )

interface Plant3processesScreensProcessesManagementRouteChildren {
  Plant3processesScreensProcessesManagementPartProcessesRoute: typeof Plant3processesScreensProcessesManagementPartProcessesRoute
  Plant3processesScreensProcessesManagementProcessesRoute: typeof Plant3processesScreensProcessesManagementProcessesRoute
  Plant3processesScreensProcessesManagementIndexRoute: typeof Plant3processesScreensProcessesManagementIndexRoute
}

const Plant3processesScreensProcessesManagementRouteChildren: Plant3processesScreensProcessesManagementRouteChildren =
  {
    Plant3processesScreensProcessesManagementPartProcessesRoute:
      Plant3processesScreensProcessesManagementPartProcessesRoute,
    Plant3processesScreensProcessesManagementProcessesRoute:
      Plant3processesScreensProcessesManagementProcessesRoute,
    Plant3processesScreensProcessesManagementIndexRoute:
      Plant3processesScreensProcessesManagementIndexRoute,
  }

const Plant3processesScreensProcessesManagementRouteWithChildren =
  Plant3processesScreensProcessesManagementRoute._addFileChildren(
    Plant3processesScreensProcessesManagementRouteChildren,
  )

interface Plant3technicianScreensTechniciansRouteChildren {
  Plant3technicianScreensTechniciansGroupedRoute: typeof Plant3technicianScreensTechniciansGroupedRoute
  Plant3technicianScreensTechniciansListRoute: typeof Plant3technicianScreensTechniciansListRoute
  Plant3technicianScreensTechniciansScheduleRoute: typeof Plant3technicianScreensTechniciansScheduleRoute
  Plant3technicianScreensTechniciansIndexRoute: typeof Plant3technicianScreensTechniciansIndexRoute
}

const Plant3technicianScreensTechniciansRouteChildren: Plant3technicianScreensTechniciansRouteChildren =
  {
    Plant3technicianScreensTechniciansGroupedRoute:
      Plant3technicianScreensTechniciansGroupedRoute,
    Plant3technicianScreensTechniciansListRoute:
      Plant3technicianScreensTechniciansListRoute,
    Plant3technicianScreensTechniciansScheduleRoute:
      Plant3technicianScreensTechniciansScheduleRoute,
    Plant3technicianScreensTechniciansIndexRoute:
      Plant3technicianScreensTechniciansIndexRoute,
  }

const Plant3technicianScreensTechniciansRouteWithChildren =
  Plant3technicianScreensTechniciansRoute._addFileChildren(
    Plant3technicianScreensTechniciansRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppsRoute: AppsRoute,
  CallbackRoute: CallbackRoute,
  LogoutRoute: LogoutRoute,
  NoPermissionRoute: NoPermissionRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  plannerScreensPlannerRoute: plannerScreensPlannerRouteWithChildren,
  FlowIndexRoute: FlowIndexRoute,
  PromptConfigurationIndexRoute: PromptConfigurationIndexRoute,
  plannerScreensJobOrderReviewStepRoute: plannerScreensJobOrderReviewStepRoute,
  plannerScreensJobOrderTimeSelectionStepRoute:
    plannerScreensJobOrderTimeSelectionStepRoute,
  Plant3processesScreensProcessesManagementRoute:
    Plant3processesScreensProcessesManagementRouteWithChildren,
  Plant3technicianScreensTechniciansRoute:
    Plant3technicianScreensTechniciansRouteWithChildren,
  Plant3MachinesScheduleRoute: Plant3MachinesScheduleRoute,
  plannerScreensJobOrderIndexRoute: plannerScreensJobOrderIndexRoute,
  Plant3AiRecommendationIndexRoute: Plant3AiRecommendationIndexRoute,
  Plant3JobSchedulerIndexRoute: Plant3JobSchedulerIndexRoute,
  Plant3ListIndexRoute: Plant3ListIndexRoute,
  Plant3MachinesIndexRoute: Plant3MachinesIndexRoute,
  SettingsEditableColumnsIndexRoute: SettingsEditableColumnsIndexRoute,
  plannerScreensJobOrderIdAssignmentRoute:
    plannerScreensJobOrderIdAssignmentRoute,
  SettingsEditableColumnsEditIndexRoute: SettingsEditableColumnsEditIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
